import { CSSProperties, useState } from "react";
import { useContent } from "../../i18n";
import "./style.scss";

const COLOURS = ["#215479", "#0f766e", "#7c2d12", "#6d28d9", "#b91c1c"];
const MEDHUB_COLOUR = "#215479";

export const BrandDemo = () => {
  const { demos } = useContent();
  const t = demos.brand;

  const [own, setOwn] = useState(false);
  const [name, setName] = useState("");
  const [colour, setColour] = useState(COLOURS[1]);

  const orgName = name.trim() || t.defaultName;
  const appColour = own ? colour : MEDHUB_COLOUR;

  return (
    <div className="demo">
      <div className="demo-stage brand-stage">
        <div className="phone brand-phone" style={{ "--app": appColour } as CSSProperties}>
          <div className="phone-bar">{own ? orgName : "MedHub"}</div>
          <div className="member-card">
            <p className="member-card-title">{t.cardTitle}</p>
            <p className="member-name">{t.member}</p>
            <p className="member-plan">{t.plan}</p>
            {!own && (
              <p className="member-sponsor">
                {t.sponsoredBy}: <b>{orgName}</b>
              </p>
            )}
          </div>
          <div className="phone-actions">
            <span>{t.newRequest}</span>
            <span>{t.requests}</span>
          </div>
        </div>
      </div>

      <div className="demo-controls">
        <fieldset>
          <legend>{t.modeLabel}</legend>
          <label className="radio">
            <input type="radio" name="brand-mode" checked={!own} onChange={() => setOwn(false)} />
            <span>{t.onMedhub}</span>
          </label>
          <label className="radio">
            <input type="radio" name="brand-mode" checked={own} onChange={() => setOwn(true)} />
            <span>{t.own}</span>
          </label>
        </fieldset>

        <label className="text-field">
          <span>{t.name}</span>
          <input
            type="text"
            value={name}
            placeholder={t.defaultName}
            maxLength={32}
            onChange={(e) => setName(e.target.value)}
          />
        </label>

        {own && (
          <fieldset>
            <legend>{t.color}</legend>
            <div className="swatches">
              {COLOURS.map((value) => (
                <button
                  key={value}
                  type="button"
                  className={value === colour ? "swatch picked" : "swatch"}
                  style={{ background: value }}
                  aria-label={value}
                  aria-pressed={value === colour}
                  onClick={() => setColour(value)}
                />
              ))}
            </div>
          </fieldset>
        )}

        <p className="demo-note">{t.note}</p>
      </div>
    </div>
  );
};
